import React, { useState, useEffect } from "react";
import { Loader } from "semantic-ui-react";
import { size, map, filter } from "lodash";
import { AcademicCycle } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { AcademicCycleItem } from "../AcademicCycleItem";

const academicCycleController = new AcademicCycle();

export function ListAcademicCycle(props) {
  const { reload, onReload, selectedYear } = props;
  const [academicCycles, setAcademicCycles] = useState(null);
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        setAcademicCycles(null);
        let response = await academicCycleController.getAcademicCycles();

        if (selectedYear) {
          response = filter(response, (cycle) => cycle.name === selectedYear);
        }

        setAcademicCycles(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [reload, accessToken, selectedYear]);

  if (!academicCycles) return <Loader active inline="centered" />;
  if (size(academicCycles) === 0)
    return "No existen años escolares registrados";

  return map(academicCycles, (academicCycle) => (
    <AcademicCycleItem
      key={academicCycle.id}
      academicCycle={academicCycle}
      onReload={onReload}
    />
  ));
}
